import ExportButtonGroup from 'portaltransparencia-common/components/ExportButtonGroup.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import SearchPagination from 'portaltransparencia-common/components/SearchPagination.react.js';
import {
  onChange,
  resetCrud
} from 'portaltransparencia-common/crud/Actions.js';
import configuration from 'portaltransparencia-common/config/Config.js';
import StorageService from 'portaltransparencia-common/libs/StorageService.js';
import { addErrorNotification } from 'portaltransparencia-common/ui/Actions.js';
import { fromJS, List, Map } from 'immutable';
import PropTypes from 'prop-types';
import React, { Component, createRef } from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';

import PageHeader from '../components/PageHeader.react.js';
import NotasExplicativas from '../notaexplicativa/Form.react';
import UltimaAtualizacaoByTable from '../ultimaatualizacao/UltimaAtualizacaoByTable.react.js';
import { findDataAtualizacaoEmendasEmpenhos } from '../ultimaatualizacao/Actions';
import * as actions from './Actions.js';
import FormFilter from './FormFilter.react.js';
import EmendaEmpenhosTable, { rotaDetalheEmenda } from './Table.react.js';
import { buildParamsQuery, SORT_PADRAO } from './UrlFilter';

const FILTER_KEY = 'filtroEmendaEmpenhos';

export class FormEmendaEmpenhos extends Component {
  static propTypes = {
    page: PropTypes.instanceOf(Map).isRequired,
    totalizador: PropTypes.instanceOf(Map),
    filtros: PropTypes.instanceOf(Map),
    tiposTransferencias: PropTypes.instanceOf(List),
    location: PropTypes.shape({ pathname: PropTypes.string }).isRequired,
    history: PropTypes.shape({ push: PropTypes.func }).isRequired,
    findEmendaEmpenhos: PropTypes.func.isRequired,
    findEmendaEmpenhosTotal: PropTypes.func.isRequired,
    findTiposTransferencias: PropTypes.func.isRequired,
    findDataAtualizacaoEmendasEmpenhos: PropTypes.func.isRequired,
    dateAtt: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    resetCrud: PropTypes.func.isRequired,
    addErrorNotification: PropTypes.func.isRequired
  };

  state = { currentSort: SORT_PADRAO };

  panelFiltro = createRef();

  componentDidMount() {
    this.props.findDataAtualizacaoEmendasEmpenhos();
    this.props.findTiposTransferencias();
    this.onResetFiltro();
  }

  findEmpenhos(filtros, page) {
    this.props.findEmendaEmpenhosTotal(filtros);
    return this.props.findEmendaEmpenhos(filtros, page);
  }

  onChangeFiltro = event => {
    this.props.onChange(FILTER_KEY, event);
  };

  onResetFiltro = () => {
    const { resetCrud, page } = this.props;
    resetCrud(FILTER_KEY);

    const filtrosIniciais = this.loadInitialFiltros();

    this.findEmpenhos(filtrosIniciais, page);
  };

  loadInitialFiltros = () => {
    const { onChange } = this.props;
    const { exercicio } = StorageService.getItem('userInfo');

    const dataInicial = `${exercicio.id}-01-01`;
    const dataFinal = `${exercicio.id}-12-31`;

    onChange(FILTER_KEY, { name: 'dataInicial', value: dataInicial });
    onChange(FILTER_KEY, { name: 'dataFinal', value: dataFinal });

    return Map({ dataInicial, dataFinal });
  };

  onConsulta = event => {
    event && event.preventDefault();
    const { page } = this.props;
    this.searchWithPage(page.set('number', 0));
    this.panelFiltro.current && this.panelFiltro.current.collapse();
  };

  searchWithPage = page => {
    const { filtros } = this.props;
    const sort = page.get('sort');
    if (sort && typeof sort === 'string') {
      const segments = sort.split(',');
      const direction = segments.pop();
      this.setState({
        currentSort: segments.map(property => ({ property, direction }))
      });
    }
    this.findEmpenhos(filtros || Map({}), page);
  };

  onViewEmenda = item => {
    const rota = rotaDetalheEmenda(item.get('esferaGoverno'));
    if (rota) {
      this.props.history.push(`${rota}/${item.get('idEmenda')}`);
    }
  };

  onViewEmpenho = item => {
    const { entidade, exercicio } = StorageService.getItem('userInfo');
    this.props.history.push(
      `empenhos/detalhe?search=id.entidade==${entidade.id}` +
        `&entidade=${entidade.id}` +
        `&exercicio=${item.get('anoEmpenho') || exercicio.id}` +
        `&empenho=${item.get('numeroEmpenho')}`
    );
  };

  exportPage = (exportType, openTab, windowParams) => {
    const { page, filtros, addErrorNotification } = this.props;
    const { currentSort } = this.state;
    const { apiURL } = configuration;

    if (page.get('content', List()).isEmpty()) {
      addErrorNotification(
        'A consulta não apresentou resultado. Não é possível exportar para o formato selecionado!'
      );
      return;
    }

    const { entidade, exercicio } = StorageService.getItem('userInfo');

    const paramsExport = new URLSearchParams({
      entidade: entidade.id,
      exercicio: exercicio.id,
      exportType
    });

    const sortQuery = (currentSort || SORT_PADRAO)
      .map(({ property, direction }) => `sort=${property},${direction}`)
      .join('&');

    const urlParams = [
      paramsExport.toString(),
      buildParamsQuery(filtros || Map({})),
      sortQuery
    ]
      .filter(Boolean)
      .join('&');

    window.open(
      `${apiURL}/api/emendas-parlamentares/contabilidade/empenhos/report?${urlParams}`,
      openTab,
      windowParams
    );
  };

  render() {
    const {
      page,
      filtros,
      location,
      totalizador,
      tiposTransferencias,
      dateAtt
    } = this.props;
    const { currentSort } = this.state;
    const pageEmpenhos = currentSort
      ? page.set('sort', fromJS(currentSort))
      : page;

    return (
      <section>
        <PageHeader location={location} />

        <NotasExplicativas pathname={location.pathname} />

        <Panel
          title="Consultar Execução Orçamentária/Financeira de Emendas Parlamentares"
          isForm
          mobileClose
          ref={this.panelFiltro}
        >
          <FormFilter
            filtros={filtros}
            onConsulta={this.onConsulta}
            onReset={this.onResetFiltro}
            onChange={this.onChangeFiltro}
            tiposTransferencias={tiposTransferencias}
          />
        </Panel>

        <Panel isForm tableResponsive expansible={false}>
          <Row>
            <Col xs={6}>
              <UltimaAtualizacaoByTable
                modulo="3"
                table="empenho"
                column="dataultimaatualizacao"
                dateAtt={dateAtt}
              />
            </Col>
            <Col xs={6}>
              <ExportButtonGroup onClick={this.exportPage} />
            </Col>
          </Row>

          <EmendaEmpenhosTable
            page={pageEmpenhos}
            totalizador={totalizador || Map({})}
            searchWithPage={this.searchWithPage}
            onViewEmenda={this.onViewEmenda}
            onViewEmpenho={this.onViewEmpenho}
          />

          <div style={{ marginTop: -20 }}>
            <SearchPagination
              page={pageEmpenhos}
              searchWithPage={this.searchWithPage}
            />
          </div>
        </Panel>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    page: state.emendaEmpenhos.get('empenhos'),
    totalizador: state.emendaEmpenhos.get('totalizador', Map({})),
    tiposTransferencias: state.emendaEmpenhos.get(
      'tiposTransferencias',
      List()
    ),
    filtros: state.crud.getIn([FILTER_KEY, 'currentRecord'], Map({})),
    dateAtt: state.ultimaAtualizacao.get('dateAtt')
  };
}

const allActions = {
  findEmendaEmpenhos: actions.findEmendaEmpenhos,
  findEmendaEmpenhosTotal: actions.findEmendaEmpenhosTotal,
  findTiposTransferencias: actions.findTiposTransferencias,
  findDataAtualizacaoEmendasEmpenhos,
  onChange,
  resetCrud,
  addErrorNotification
};

export default connect(mapStateToProps, allActions)(FormEmendaEmpenhos);
